module.exports = __webpack_public_path__ + "static/img/img-main-features-setcion-1-m.c46cd65.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/img-main-features-setcion-1-m.png
// module id = zfYy
// module chunks = 18